module.exports = __webpack_public_path__ + "img/temoignage-3.24b92d75.jpg";